module.exports = __webpack_public_path__ + "img/D16-australia.9c6ae919.png";